import React from 'react';
import PostList from '../components/PostList';
import posts from '../data/posts';

function Home() {
  return (
    <main className="min-h-screen bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        {/* Hero Section */}
        <div className="text-center mb-16 space-y-4">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
            Welcome, I'm <span className="text-blue-600">Mayank Soni</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            DevOps Engineer & Cloud enthusiast. Sharing thoughts and tutorials on AWS, Kubernetes, Terraform, and modern infrastructure.
          </p>
        </div>

        {/* Blog Posts Grid */}
        <div className="space-y-8">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-900">Latest Posts</h2>
          </div>
          <PostList posts={posts} />
        </div>
      </div>
    </main>
  );
}

export default Home;